<template src="./Prescriptions.html"></template>

<script>
import { showAlert } from "@/utils/helpers";

export default {
  props: {
    itemId: {
      type: Number,
      required: true,
    },
    doctorId: {
      type: Number,
      required: true,
    },
  },
  created() {
    this.$store.dispatch("lookups/getAllItemPriceList", "صيدلية");
    this.$store.dispatch("doctorsAppointments/getForEdit", this.itemId)
      .then((res) => {
        this.appointment = res;
      });
  },
  computed: {
    itemPriceList() {
      return this.$store.state.lookups.itemPriceList || [];
    },
    doctors() {
      return [
        ...this.$store.state.lookups.doctors];
    },

  },
  data() {
    return {
      appointment: {
        fullName: null,
        fileNo: null,
        appointmentType: null,
        appointmentDate: null,
      },
      formDialog: false,
      vm: {
        doctorId: null,
        patientId: null,
        appointmentDate: null,
        items: []
      },
      medicine: {
        serviceName: null,
        quantity: null,
      },
      indexItem: null,
      editFlag: false,
      headers: [
        { text: 'اسم الدواء', value: 'serviceName' },
        { text: 'الكمية', value: 'quantity' },
        { text: 'الاجراءات', value: 'actions', sortable: false },
      ],
    };
  },
  methods: {
    confirm() {
      if (this.vm.items.length == 0) {
        showAlert(`يجب ادخال عنصر واحد على الاقل`);
        return false;
      }
        this.vm.patientId = this.appointment.patientId;
      this.vm.appointmentDate = this.appointment.appointmentDate;
      this.vm.doctorId = this.appointment.doctorId;
      
      this.$store
        .dispatch("doctorPrescriptions/add", this.vm )
        .then(() => {
          this.back();
        })
        .catch(() => { });

    },

    AddItem() {
      if (this.medicine.serviceName == null) {
        showAlert(`يجب اختيار الدواء `);
        return false;
      } else if (this.medicine.quantity == null) {
        showAlert(`يجب ادخال الكمية   `);
        return false;
      }

      let isFound = false;
      this.vm.items.forEach(element => {
        if (element.serviceName == this.medicine.serviceName) {
          showAlert(`الدواء مضاف مسبقا`);
          isFound = true;
        }
      });

      if (isFound) {
        showAlert(`الدواء مضاف مسبقا`);
        return false;
      }
      let medicine = this.itemPriceList.find(x => x.itemName == this.medicine.serviceName);
      this.vm.items.push({
        serviceName: this.medicine.serviceName,
        serviceCode: medicine.itemCode,
        quantity: this.medicine.quantity,
        price: medicine.price
      });

      this.medicine.serviceName = null;
      this.medicine.quantity = null;
      // this.stock = [];

      this.$refs.form.reset();
    },
    removeItem(index) {
      this.vm.items.splice(index, 1);
    },
    back() {
      this.$emit("back");
    },
  },
};
</script>